import { render, staticRenderFns } from "./AddressListList.vue?vue&type=template&id=09f44c4a"
import script from "./AddressListList.vue?vue&type=script&lang=ts"
export * from "./AddressListList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports